import { VENDORS_ACTIONS } from './vendors.types'

/**
 * @param {import('./vendors.types').Vendor} payload
 * @returns {Object}
 */
export const setVendorAction = payload => ({
  type: VENDORS_ACTIONS.SET_VENDOR,
  payload
})

/**
 * @param {Array<import('./vendors.types').Vendor>} payload
 * @returns {Object}
 */
export const setVendorsAction = payload => ({
  type: VENDORS_ACTIONS.SET_VENDORS,
  payload
})

/**
 * @param {import('../slice.types').SliceStatus} payload
 * @returns {Object}
 */
export const setVendorsStatusAction = payload => ({
  type: VENDORS_ACTIONS.SET_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {Object}
 */
export const setVendorsErrorsAction = payload => ({
  type: VENDORS_ACTIONS.SET_ERRORS,
  payload
})

/**
 * @returns {Object}
 */
export const clearVendorsErrorsAction = () => ({
  type: VENDORS_ACTIONS.CLEAR_ERRORS
})
